import { Action, Selector, State, StateContext } from '@ngxs/store';
import { Injectable } from '@angular/core';
import { RContract } from './r-contract.action';
import { UserPrivilegeEnum } from '../../../../enums/rights/user-privilege.enum';
import { ResetStateDefaults } from '../../../base-action-class.model';


interface RContractXsStateModel {
  viewContract: string;
  createContract: string;
  editContract: string;
  deleteContract: string;

  viewContractAccessMappings: string;
}

const getDefaults = (): RContractXsStateModel => ({
  viewContract: null,
  createContract: null,
  editContract: null,
  deleteContract: null,

  viewContractAccessMappings: null
});

@State<RContractXsStateModel>({
  name: 'rContract',
  defaults: getDefaults()
})
@Injectable()
export class RContractXsState {

  //region SELECTOR
  @Selector()
  static canViewContract(state: RContractXsStateModel): boolean {
    return state.viewContract != null;
  }

  @Selector()
  static canCreateContract(state: RContractXsStateModel): boolean {
    return state.createContract != null;
  }

  @Selector()
  static canEditContract(state: RContractXsStateModel): boolean {
    return state.editContract != null;
  }

  @Selector()
  static canDeleteContract(state: RContractXsStateModel): boolean {
    return state.deleteContract != null;
  }

  @Selector()
  static canViewContractAccessMappings(state: RContractXsStateModel): boolean {
    return state.viewContractAccessMappings != null;
  }
  //endregion

  //region ACTIONS
  @Action(RContract.SetContractPrivileges)
  public setContractPrivileges(ctx: StateContext<RContractXsStateModel>, action: RContract.SetContractPrivileges) {
    const state = ctx.getState();
    const privileges = [...action.activeUserRightsRoleDtoModel.contractPrivileges];

    //find user privilege data model
    const viewContract = privileges.find(id => id === UserPrivilegeEnum.VIEW_PLATFORM_CONTRACT);
    const createContract = privileges.find(id => id === UserPrivilegeEnum.CREATE_PLATFORM_CONTRACT);
    const editContract = privileges.find(id => id === UserPrivilegeEnum.EDIT_PLATFORM_CONTRACT);
    const deleteContract = privileges.find(id => id === UserPrivilegeEnum.DELETE_PLATFORM_CONTRACT);

    const viewContractAccessMappings = privileges.find(id => id === UserPrivilegeEnum.VIEW_CONTRACT_ACCESS_MAPPINGS);

    //set the state
    ctx.setState({
      ...state,
      viewContract: viewContract,
      createContract: createContract,
      editContract: editContract,
      deleteContract: deleteContract,
      viewContractAccessMappings: viewContractAccessMappings
    });
  }

  @Action(ResetStateDefaults)
  public resetDefaults(ctx: StateContext<RContractXsStateModel>): void {
    ctx.setState({...getDefaults()});
  }
  //endregion

}
